import { useQuery } from '@tanstack/react-query';
import { API_CLIENT } from '../api-new';

export const useMachineStatus = () => {
  return useQuery({
    queryKey: ['machine-status'],
    queryFn: () => API_CLIENT.current_machine_status(),
  });
};
